import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { RouterModule } from '@angular/router'

import { DetailKpiCard } from '../models/detail-page.model'

@Component({
    selector: 'app-detail-kpi-row',
    standalone: true,
    imports: [CommonModule, RouterModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './detail-kpi-row.component.html',
    styleUrls: ['./detail-kpi-row.component.scss']
})
export class DetailKpiRowComponent {
    @Input() cards: DetailKpiCard[] = []
    @Input() testId?: string
    @Output() linkClicked = new EventEmitter<DetailKpiCard>()

    onLink(card: DetailKpiCard): void {
        this.linkClicked.emit(card)
    }

    subClass(tone: string | undefined): string {
        switch (tone) {
            case 'good':  return 'detail-kpi-sub good'
            case 'over':  return 'detail-kpi-sub over'
            case 'under': return 'detail-kpi-sub under'
            default:      return 'detail-kpi-sub muted'
        }
    }
}
